import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: []
})
export class PaginationComponent {
  @Input() page: number = 1;
  @Output() pageChange = new EventEmitter<number>();
  @Input() collectionSize: number = 0
  @Input() pageSize: number = 10

  onPageChange(page: number): void{
    this.pageChange.emit(page);
  }

}
